export default __webpack_public_path__ + "static/media/p2023-17.7c92351b.jpeg";